import { createRoot } from 'react-dom/client'

import { Provider as StoreProvider } from 'react-redux'
import { HashRouter, Route, Routes } from 'react-router-dom'

import { msalInstance } from './authConfig'
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'

import { GoogleAnalyticsProvider } from '@services/providers/ganalytics'
import { GA_CONFIG, PAGE_TRACKING_DATA } from '@features/config/analytics'

import { routes } from '@features/routes'
import Store from '@services/store/store'

import 'typeface-roboto'
import './index.css'

import Auth from '@views/Auth'
import Layout from '@components/Layout'
import Config from '@features/config.json'

const DEFAULT_THEME = 'default'
const DEFAULT_MODE = 'light'

const store = Store()
const root = createRoot(document.getElementById('root'))

let themeMode = localStorage.getItem('theme.mode')
let themeTheme = localStorage.getItem('theme.theme')

if (!themeMode) localStorage.setItem('theme.mode', Config.interface?.theme?.mode?.toLowerCase() ?? DEFAULT_MODE)
if (!themeTheme) localStorage.setItem('theme.theme', Config.interface?.theme?.theme?.toLowerCase() ?? DEFAULT_THEME)
else {
    if (themeTheme !== Config.interface?.theme?.theme?.toLowerCase() ?? DEFAULT_THEME)
        localStorage.setItem('theme.theme', Config.interface?.theme?.theme?.toLowerCase() ?? DEFAULT_THEME)
}

const initialAnalyticsData = {
    ...GA_CONFIG.default_data,
    ...PAGE_TRACKING_DATA.lz.list
}

root.render(
    <HashRouter>
        <MsalProvider instance={msalInstance}>
            <StoreProvider store={store}>
                <GoogleAnalyticsProvider initialData={initialAnalyticsData}>
                    <Layout>
                        <AuthenticatedTemplate>
                            <Routes>
                                {routes.map((route, index) => (
                                    <Route {...route} key={index}/>
                                ))}
                            </Routes>
                        </AuthenticatedTemplate>
                        <UnauthenticatedTemplate>
                            <Auth />
                        </UnauthenticatedTemplate>
                    </Layout>
                </GoogleAnalyticsProvider>
            </StoreProvider>
        </MsalProvider>
    </HashRouter>
)